import MobileWidgetCards from "../MobileWidgetCards/MobileWidgetCards";
import AssetGradientCard from './AssetGradientCard/AssetGradientCard';


const MobileWidgetGradientCardsIcon = (props) => <MobileWidgetCards
    assetsCount={10}
    collectionKey={props.collectionKey}
    widgetCardItem={AssetGradientCard}
    widgetCardItemProps={props}
/>;

export default MobileWidgetGradientCardsIcon;
